import { render } from "./PlacesWidget.vue?vue&type=template&id=30caf43f"
import script from "./PlacesWidget.vue?vue&type=script&lang=js"
export * from "./PlacesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__